import Route from '@/routes/index'
import Qs from 'qs'

function compare (data1, data2) {
    let k1 = Object.keys(data1)
    let k2 = Object.keys(data2)
    if (!k1 || !k2) return
    return k1.every(e => (typeof data1[e] === 'object') ? true : k2.includes(e))
}
const state = {
    conditions: {
    }
}
const getters = {
    initCondition: (state) => (payload) => {
        let key = (payload.key) ? payload.key : Route.currentRoute.name
        if (typeof state.conditions[key] === 'undefined') {
            let q = Route.currentRoute.query
            let data = payload.model
            if (Object.keys(q).length && compare(data, q)) {
                for (let d in data) {
                    switch (typeof data[d]) {
                        case 'string':
                            if (q[d] !== '' && !isNaN(q[d])) {
                                q[d] = parseInt(q[d])
                            }
                            break
                        case 'number':
                            q[d] = parseInt(q[d])
                            break
                        case 'boolean':
                            q[d] = (q[d] === 'true')
                            break
                        case 'object':
                            if (typeof q[d] !== 'object') {
                                if (data[d] === null) {
                                    q[d] === data[d]
                                    break
                                }
                                q[d] = [...data[d]]
                            }
                            for (let a in q[d]) {
                                if (q[d] !== '' && !isNaN(q[d][a])) {
                                    q[d][a] = parseInt(q[d][a])
                                }
                            }
                            break
                    }
                }
                data = {...q}
            }
            state.conditions[key] = {...data}
            return data
        } else {
            return state.conditions[key]
        }
    }
}
const mutations = {
    setCondition  (state, payload) {
        let key = (payload.key) ? payload.key : Route.currentRoute.name
        let query = { ...Route.currentRoute.query, ...payload.model }
        query = Qs.stringify(query, {arrayFormat: 'repeat'})
        let str = Route.currentRoute.path + '?' + query
        Route.replace({path: str})
        state.conditions[key] = payload.model
    }
}
const actions = {

}

export default {
    state,
    getters,
    mutations,
    actions
}
